import {createSlice} from '@reduxjs/toolkit';

export const perfectStoreInitialFormData = {
  targetType: '',
  name: '',
  nameValid: undefined,
  status: 'Draft',
  activeStartDate: '',
  activeStartDateValid: undefined,
  activeEndDate: '',
  activeEndDateValid: undefined,
  rewardDate: '',
  rewardDateValid: undefined,
  hasDisplayDate: false,
  displayStartDate: '',
  displayStartDateValid: undefined,
  displayEndDate: '',
  displayEndDateValid: undefined,
  awardPointsWhenTargetMet: false,
  requiredUserToJoin: false,
  targetMediaFile: [],
  storeTargetFileUrl: '',
  displayContent: {
    bannerImage: null,
    bannerText: {},
    rackDisplays: []
  }
};

export const perfectStoreInitialState = {
  formData: {...perfectStoreInitialFormData},
  id: null,
  uuid: null,
  status: null
};

const perfectStoreSlice = createSlice({
  name: 'perfectStore',
  initialState: perfectStoreInitialState,
  reducers: {
    setPerfectStoreFormData: (state, action) => ({
      ...state,
      formData: {
        ...state.formData,
        ...action.payload
      }
    }),
    resetPerfectStoreFormData: (state, action) => ({
      ...state,
      formData: {
        ...perfectStoreInitialFormData,
        ...(action.payload || {})
      }
    }),
    resetPerfectStore: () => ({...perfectStoreInitialState}),
    setPerfectStoreMeta: (state, action) => ({
      ...state,
      ...action.payload
    })
  }
});

export const {
  setPerfectStoreFormData,
  resetPerfectStoreFormData,
  resetPerfectStore,
  setPerfectStoreMeta
} = perfectStoreSlice.actions;

export const perfectStoreSliceReducer = perfectStoreSlice.reducer;
